import { render, staticRenderFns } from "./CustomerCreatePartial.vue?vue&type=template&id=b8e8383e&scoped=true&"
import script from "./CustomerCreatePartial.vue?vue&type=script&lang=js&"
export * from "./CustomerCreatePartial.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreatePartial.vue?vue&type=style&index=0&id=b8e8383e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e8383e",
  null
  
)

export default component.exports